export const LoadingIcon = ({ className }) => {
  return (
    <>
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="200px"
        height="200px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        // style="margin-right:-2px;display:block;background-repeat-y:initial;background-repeat-x:initial;animation-play-state:paused"
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          // stroke="#fb7268"
          stroke="currentColor"
          strokeWidth={"10"}
          r="35"
          strokeDasharray="164.93361431346415 56.97787143782138"
          transform="matrix(1,0,0,1,0,0)"
          //   style="transform:matrix(1, 0, 0, 1, 0, 0);animation-play-state:paused"
        ></circle>
      </svg>
    </>
  );
};
